import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, IconButton, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useContext, useState } from "react";
import { DataContext } from "../DataContext";
import PhotosPreview from "../ui/PhotosPreview";
import moment from "moment";
import SelectInput from "../ui/SelectInput";
import { CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox, Search } from "@mui/icons-material";
import { variables } from "../../styles/abstract/variables";
import $data from "../../services/$data";
import { AppContext } from "../../AppContext";

const tagsValues = {
  'None': 'None',
  'Red zone - Row': 'R_R',
  'Red zone - Between rows': 'B_R',
  'Green zone - Row': 'R_G',
  'Green zone - Between rows': 'B_G',
  'Yellow zone - Row': 'R_Y',
  'Yellow zone - Between rows': 'B_Y',
  'Witness': 'W',
  'Applicability': 'AP',
  'Fertilization': 'F',
  'Pesticides': 'PE',
  'Soil management': 'S',
  'Pruning': 'PR',
  'Harvesting': 'H',
  'Resiudes management': 'RM',
  'Irrigation': 'I',
  'Animals': 'AN',
  'Soil Organic Carbon': 'SOC',
  'Planting': 'PL',
  'Biomass Management': 'BM',
};

const tagsLabels = {
  'None': 'None',
  'R_R': 'Red zone - Row',
  'B_R': 'Red zone - Between rows',
  'R_G': 'Green zone - Row',
  'B_G': 'Green zone - Between rows',
  'R_Y': 'Yellow zone - Row',
  'B_Y': 'Yellow zone - Between rows',
  'W': 'Witness',
  'AP': 'Applicability',
  'F': 'Fertilization',
  'PE': 'Pesticides',
  'S': 'Soil management',
  'PR': 'Pruning',
  'H': 'Harvesting',
  'RM': 'Resiudes management',
  'I': 'Irrigation',
  'AN': 'Animals',
  'SOC': 'Soil Organic Carbon',
  'PL': 'Planting',
  'BM': 'Biomass Management',
}

function CarbonPhotosModal(props) {
  const {selected} = useContext(AppContext)
  const { projectData } = useContext(DataContext);

  const photos = props.photos ? props.photos : projectData[props.projectId].photos;
  
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const [tag, setTag] = useState(props.tag || 'All');

  const [parcel, setParcel] = useState(props.parcel || 'All');

  const [year, setYear] = useState(props.year || 'All');

  const [marked, setMarked] = useState([]);

  const onSetMarked = (photo) => {

    if(marked.indexOf(photo.id) > -1) {
      setMarked(marked.filter(m => m !== photo.id));
    } else {
      setMarked(current => [...current, photo.id]);
    }

  }

  const onSubmit = async () => {
    console.log(selected)
    try {
      await $data.updatePhotos(marked, props.parcelId);
      await props.onRefreshPhotos(selected);
      props.onClose();
    } catch (error) {
      
    }
  }

  const renderPhotos = () => {
    if (!photos) return (
      <Typography variant="body2" color="error"><strong>Something went wrong while trying to display photos</strong></Typography>
    )

    if (photos.length === 0) {
      return (
        <Typography variant="body1" color="primary"><strong>There are no uploaded photos</strong></Typography>
      )
    }
    let filtered = photos.filter(p => !p.parcel)


    filtered = photos.filter(p => {
      if (tag === 'All') return true;
      if (tag.indexOf(p.tag) > -1) {
        return true;
      } else {
        return false
      }

    });

    filtered = [...filtered].filter(p => {
      if (year === 'All') return true;
      if (year === moment(p.date_time).format('YYYY')) {
        return true;
      } else {
        return false
      }
    });

    filtered = [...filtered].filter(p => {
      if (parcel === 'All') return true;
      if (parcel === p.parcel) {
        return true
      } else {
        return false
      }

    })


    if (filtered.length === 0) {
      return (
        <Typography variant="body1" color="primary"><strong>There are no photos that match your filter query</strong></Typography>
      )
    }

    if(props.selectable) {
      return (
        <Grid container spacing={2}>
          {filtered.map((p, key) => {
            return (
              <Grid key={key} item xs={12} sm={4} md={3} lg={2}>
                <Paper elevation={3} style={{border: marked.indexOf(p.id) > -1 ? `4px solid ${variables.secondary}` : 'none', position: 'relative', backgroundImage: `url("${p.image}")`, backgroundPosition: 'center', backgroundSize: 'cover' }} sx={{ width: '100%', height: '150px', '&:hover': { cursor: 'pointer', transform: 'scale(1.03)' } }}>
                  {p.tag && <Chip size="small" label={`#${tagsLabels[p.tag]}`} color="warning" variant="filled" sx={{ position: 'absolute', bottom: '2px', left: '2px', cursor: 'pointer' }} />}
                  <Stack sx={{position: 'absolute', top: '4px', width: '100%'}} direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                    <Fab onClick={() => setSelectedPhoto(p)} sx={{minHeight: '28px', height: '28px', minWidth: '28px', width: '28px'}} color="secondary" size="small"><Search fontSize="small" /></Fab>
                    <Fab onClick={() => onSetMarked(p)} sx={{minHeight: '28px', height: '28px', minWidth: '28px', width: '28px'}} color="secondary" size="small">{marked.indexOf(p.id) > -1 ? <CheckBox fontSize="small" /> :  <CheckBoxOutlineBlank fontSize="small" />}</Fab>
                  </Stack>
                </Paper>
              </Grid>
            )
          })}
        </Grid>
      )
    }

    return (
      <Grid container spacing={2}>
        {filtered.map((p, key) => {
          return (
            <Grid key={key} item xs={12} sm={4} md={3} lg={2}>
              <Paper onClick={() => setSelectedPhoto(p)} elevation={3} style={{ position: 'relative', backgroundImage: `url("${p.image}")`, backgroundPosition: 'center', backgroundSize: 'cover' }} sx={{ width: '100%', height: '150px', '&:hover': { cursor: 'pointer', transform: 'scale(1.03)' } }}>
                {p.tag && <Chip size="small" label={`#${p.tag}`} color="warning" variant="filled" sx={{ position: 'absolute', bottom: '2px', left: '2px', cursor: 'pointer' }} />}
              </Paper>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  const renderFilters = () => {
    return (
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="body2" color="primary"><strong>Filter by: </strong></Typography>
          </Grid>
          {props.tags && <Grid item xs={12} sm={6} md={4}>
            <SelectInput value={tag} onChange={(e) => setTag(e.target.value)} fullWidth items={props.tags} name="Tag" />
          </Grid>}
          {/* <Grid item xs={12} sm={6} md={4}>
            <SelectInput value={parcel} onChange={(e) => setParcel(e.target.value)} fullWidth items={[{ value: 'All', label: 'All' }, ...parcels.map(p => ({ value: p.id, label: p.name }))]} name="Parcel" />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4}>
            <SelectInput value={year} onChange={(e) => setYear(e.target.value)} fullWidth items={['All', ...new Set(photos.map(obj => moment(obj.date_time).format('YYYY')))].map(y => ({ value: y, label: y }))} name="Year" />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <Dialog PaperProps={{ className: 'co-background-white' }} fullWidth maxWidth="lg" open={props.open} onClose={props.onClose}>

      <DialogTitle color="primary">Attach geo-tagged photos</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: '20px' }}>
          {/* {renderFilterTags()}
          {renderPhotosYear()}
          {renderFilterParcels()} */}
          {renderFilters()}
          <Grid item xs={12}>
            {renderPhotos()}
          </Grid>

        </Grid>

      </DialogContent>
      <DialogActions>
        {props.selectable && <Button onClick={onSubmit} disabled={marked.length === 0} style={{ lineHeight: 'unset' }} variant="contained" color="primary" >Attach to parcel</Button>}
        <Button style={{ lineHeight: 'unset' }} color="error" onClick={props.onClose}>Cancel</Button>

      </DialogActions>
      {selectedPhoto && <PhotosPreview open={Boolean(selectedPhoto)} photos={[selectedPhoto]} onClose={() => { setSelectedPhoto(null) }} />}

    </Dialog>
  )
}

export default CarbonPhotosModal;